export default "__VITE_ASSET__DQKCF01C__"